'use es6';

import ErrorPage from 'ContentEditorUI/components/app/ErrorPage';
import { APP_ERRORS } from 'ContentEditorUI/lib/app/constants';
import { jsx as _jsx } from "react/jsx-runtime";
export default (() => /*#__PURE__*/_jsx(ErrorPage, {
  appErrorCategory: APP_ERRORS.NOT_FOUND
  // Assume canContactSupport is false when we have to show a "not found" error before we have scopes info
  ,
  canContactSupport: false
}));